export enum CapitalAccountStatementActions {
  downloadReport = "CapitalAccountStatement/downloadReport",
}
